import React from 'react'

type Props = {
  children: React.ReactNode
  id?: string
}

const ValidationMessage = ({ children, id }: Props) => {
  return (
    <span aria-live="polite" id={id} className="u-color-danger">
      {children}
    </span>
  )
}

export default ValidationMessage
